// Nuxt only finds middleware if they're in the directory `middleware`.
// Read more: https://fr.nuxtjs.org/guide/routing#middleware
import notSeller from '@auth-oauth2/middleware/notSeller'

export default notSeller
